import GoogleSheetsLogoSvg from "@/components/UI/svg/GoogleSheetsLogoSvg.vue";
import VKAdsSvg from "@/components/UI/svg/services/VKAdsSvg.vue";
import YandexDirectSVG from "@/components/UI/Logos/YandexDirectSVG.vue";

const INTEGRATION_ICONS = {
    google_sheets: GoogleSheetsLogoSvg,
    google: GoogleSheetsLogoSvg,
    vk_ads: VKAdsSvg,
    yandex_direct: YandexDirectSVG,
};

function formatDateLabel(value) {
    if (!value) {
        return '—';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
}

function formatRelativeSyncLabel(value) {
    if (!value) {
        return '—';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    const diffMs = Date.now() - date.getTime();
    const diffMinutes = Math.floor(diffMs / 60000);

    if (diffMinutes < 1) {
        return 'Только что';
    }
    if (diffMinutes < 60) {
        return `${diffMinutes} мин. назад`;
    }

    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) {
        return `${diffHours} ч. назад`;
    }

    const diffDays = Math.floor(diffHours / 24);
    if (diffDays === 1) {
        return `Вчера, ${new Intl.DateTimeFormat('ru-RU', {
            hour: '2-digit',
            minute: '2-digit',
        }).format(date)}`;
    }

    return new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
}

export function isGoogleIntegration(code) {
    return code === 'google_sheets' || code === 'google';
}

export function mapIntegration(integration) {
    const code = integration.code;

    return {
        id: integration.id,
        code,
        name: integration.name,
        status: integration.status,
        icon: INTEGRATION_ICONS[code] || GoogleSheetsLogoSvg,
        type: integration.type || '',
        description: integration.description || '',
        connectionsCount: integration.connections_count ?? 0,
        lastSync: integration.last_sync_label || formatRelativeSyncLabel(integration.last_sync_at),
        account: integration.account || '—',
        connectedAt: integration.connected_at_label || formatDateLabel(integration.connected_at),
        statusHint: integration.status_hint || '',
        isConnected: integration.is_connected ?? Boolean(integration.account),
    };
}

export function mapIntegrationsReport(data) {
    const integrations = Array.isArray(data) ? data : data?.integrations || [];
    return integrations.map(mapIntegration);
}
